<div class="card mb-5">

    <!-- ================================================= -->
    <!-- HEADER -->
    <!-- ================================================= -->

    <div class="card-header">

        <div
            class="
                d-flex
                justify-content-between
                align-items-center
            "
        >

            <div>

                <h3 class="mb-1">
                    Transformación de Productos
                </h3>

                <small class="text-muted">

                    Selecciona una bodega y el producto al que deseas
                    realizar la transformación.

                </small>

            </div>

        </div>

    </div>


    <!-- ================================================= -->
    <!-- BODY -->
    <!-- ================================================= -->

    <div class="card-body">


        <!-- ================================================= -->
        <!-- BODEGA -->
        <!-- ================================================= -->

        <div class="row mb-4">

            <div class="col-md-6 col-sm-12">

                <div class="form-group">

                    <!-- CARGANDO BODEGAS -->

                    <div
                        *ngIf="loadingWarehouses"
                        class="text-muted mb-2"
                    >

                        <span
                            class="
                                spinner-border
                                spinner-border-sm
                                me-1
                            "
                        ></span>

                        Cargando bodegas...

                    </div>

                    <div class="row mb-4">

                        <div class="col-md-10 col-sm-12">

                            <div class="form-group">

                                <label
                                    for="warehouse"
                                    class="form-label"
                                >
                                    Bodega
                                    <span class="required">*</span>
                                </label>

                                <select
                                    id="warehouse"
                                    class="form-select"
                                    [(ngModel)]="selectedWarehouseId"
                                    (ngModelChange)="onWarehouseChange($event)"
                                    [disabled]="loadingWarehouses"
                                >

                                    <option [ngValue]="null">
                                        Seleccione una bodega
                                    </option>

                                    <option
                                        *ngFor="let warehouse of warehouses"
                                        [ngValue]="warehouse.id"
                                    >
                                        {{ warehouse.code }} - {{ warehouse.name }}
                                    </option>

                                </select>

                                <small
                                    *ngIf="selectedWarehouse"
                                    class="text-muted mt-1 d-block"
                                >
                                    {{ selectedWarehouse.address || 'Sin dirección' }}
                                </small>

                            </div>

                        </div>

                    </div>


                    <!-- BODEGA SELECCIONADA -->

                    <small
                        *ngIf="selectedWarehouse"
                        class="text-success mt-1 d-block"
                    >

                        <i
                            class="
                                fa-solid
                                fa-circle-check
                                me-1
                            "
                        ></i>

                        {{ selectedWarehouse.name }}

                        <span
                            *ngIf="selectedWarehouse.code"
                        >

                            ({{ selectedWarehouse.code }})

                        </span>

                    </small>

                </div>

            </div>

        </div>


        <!-- ================================================= -->
        <!-- SIN BODEGA -->
        <!-- ================================================= -->

        <div
            *ngIf="
                !selectedWarehouse &&
                !loadingWarehouses
            "
            class="
                alert
                alert-light
                border
                text-center
            "
        >

            <i
                class="
                    fa-solid
                    fa-warehouse
                    me-2
                "
            ></i>

            Selecciona una bodega para consultar los productos
            disponibles.

        </div>


        <!-- ================================================= -->
        <!-- LOADING PRODUCTOS -->
        <!-- ================================================= -->

        <div
            *ngIf="loading"
            class="text-center py-5"
        >

            <div
                class="
                    spinner-border
                    text-primary
                "
                role="status"
            >

                <span class="visually-hidden">

                    Cargando...

                </span>

            </div>


            <div class="mt-2 text-muted">

                Cargando productos disponibles para transformación...

            </div>

        </div>


        <!-- ================================================= -->
        <!-- SIN PRODUCTOS -->
        <!-- ================================================= -->

        <div
            *ngIf="
                selectedWarehouse &&
                !loading &&
                products.length === 0
            "
            class="
                alert
                alert-light
                border
                text-center
            "
        >

            <i
                class="
                    fa-solid
                    fa-box-open
                    me-2
                "
            ></i>

            No existen productos disponibles para transformación
            en esta bodega.

        </div>


        <!-- ================================================= -->
        <!-- TABLA -->
        <!-- ================================================= -->

        <div
            *ngIf="
                selectedWarehouse &&
                !loading &&
                products.length > 0
            "
            class="table-responsive"
        >

            <table
                class="
                    table
                    table-bordered
                    table-hover
                    align-middle
                "
            >

                <thead>


                    <!-- ========================================= -->
                    <!-- GRUPOS -->
                    <!-- ========================================= -->

                    <tr>

                        <th
                            colspan="3"
                            class="text-center bg-light"
                        >

                            Producto Actual

                        </th>


                        <th
                            colspan="3"
                            class="text-center bg-light"
                        >

                            Transformación

                        </th>


                        <th class="bg-light"></th>

                    </tr>


                    <!-- ========================================= -->
                    <!-- COLUMNAS -->
                    <!-- ========================================= -->

                    <tr>

                        <th style="width: 120px;">

                            Código

                        </th>


                        <th>

                            Producto

                        </th>


                        <th
                            class="text-center"
                            style="width: 140px;"
                        >

                            Existencia

                        </th>


                        <th
                            style="min-width: 320px;"
                        >

                            Transformar a

                        </th>


                        <th
                            class="text-center"
                            style="width: 160px;"
                        >

                            Factor

                        </th>


                        <th
                            class="text-center"
                            style="width: 180px;"
                        >

                            Resultado

                        </th>


                        <th
                            class="text-center"
                            style="width: 100px;"
                        >

                            Acción

                        </th>

                    </tr>

                </thead>


                <tbody>


                    <tr
                        *ngFor="
                            let product of products;
                            trackBy: trackByProduct
                        "
                    >


                        <!-- ================================= -->
                        <!-- CÓDIGO -->
                        <!-- ================================= -->

                        <td>

                            <strong>

                                {{ product.product.code }}

                            </strong>

                        </td>


                        <!-- ================================= -->
                        <!-- PRODUCTO -->
                        <!-- ================================= -->

                        <td>

                            <div class="product-name">

                                {{ product.product.name }}

                            </div>


                            <small
                                *ngIf="
                                    product.targetProducts.length > 0
                                "
                                class="
                                    text-muted
                                    transformation-count
                                "
                            >

                                {{
                                    product.targetProducts.length
                                }}

                                transformación(es) disponible(s)

                            </small>


                            <small
                                *ngIf="
                                    product.targetProducts.length === 0
                                "
                                class="text-muted"
                            >

                                Sin transformaciones disponibles

                            </small>

                        </td>


                        <!-- ================================= -->
                        <!-- EXISTENCIA -->
                        <!-- ================================= -->

                        <td class="text-center">

                            <span
                                class="
                                    badge
                                    bg-light
                                    text-dark
                                    border
                                "
                            >

                                {{
                                    product.existingQuantity
                                    | number:'1.0-4'
                                }}

                            </span>

                        </td>


                        <!-- ================================= -->
                        <!-- TRANSFORMAR A -->
                        <!-- ================================= -->

                        <td>

                            <select
                                class="
                                    form-select
                                    form-select-sm
                                "

                                [(ngModel)]="
                                    product.selectedTargetProductId
                                "

                                (ngModelChange)="
                                    onTransformationChange(product)
                                "

                                [disabled]="
                                    product.targetProducts.length === 0
                                "
                            >

                                <option
                                    [ngValue]="null"
                                >

                                    Seleccione una transformación

                                </option>


                                <option
                                    *ngFor="
                                        let transformation
                                        of product.targetProducts;
                                        trackBy:
                                            trackByTransformation
                                    "

                                    [ngValue]="
                                        transformation.targetProduct.id
                                    "
                                >

                                    {{
                                        transformation
                                            .targetProduct
                                            .code
                                    }}

                                    -

                                    {{
                                        transformation
                                            .targetProduct
                                            .name
                                    }}

                                </option>

                            </select>


                            <div
                                *ngIf="
                                    product.selectedTransformation
                                "
                                class="mt-2"
                            >

                                <small class="text-muted">

                                    Se transformará en:

                                </small>


                                <div>

                                    <strong>

                                        {{
                                            product
                                                .selectedTransformation
                                                .targetProduct
                                                .name
                                        }}

                                    </strong>

                                </div>

                            </div>

                        </td>


                        <!-- ================================= -->
                        <!-- FACTOR -->
                        <!-- ================================= -->

                        <td class="text-center">

                            <ng-container
                                *ngIf="
                                    product.selectedTransformation;
                                    else noFactor
                                "
                            >

                                <span class="text-muted">

                                    1

                                </span>


                                <i
                                    class="
                                        fa-solid
                                        fa-arrow-right
                                        mx-2
                                    "
                                ></i>


                                <strong>

                                    {{
                                        product
                                            .selectedTransformation
                                            .factor
                                        | number:'1.0-4'
                                    }}

                                </strong>

                            </ng-container>


                            <ng-template #noFactor>

                                <span class="text-muted">

                                    -

                                </span>

                            </ng-template>

                        </td>


                        <!-- ================================= -->
                        <!-- RESULTADO -->
                        <!-- ================================= -->

                        <td class="text-center">

                            <ng-container
                                *ngIf="
                                    product.selectedTransformation;
                                    else noResult
                                "
                            >

                                <strong
                                    class="
                                        text-primary
                                        transformation-result
                                    "
                                >

                                    {{
                                        calculateResult(product)
                                        | number:'1.0-4'
                                    }}

                                </strong>


                                <div>

                                    <small class="text-muted">

                                        unidades

                                    </small>

                                </div>

                            </ng-container>


                            <ng-template #noResult>

                                <span class="text-muted">

                                    -

                                </span>

                            </ng-template>

                        </td>


                        <!-- ================================= -->
                        <!-- ACCIÓN -->
                        <!-- ================================= -->

                        <td class="text-center">

                            <button
                                type="button"

                                class="
                                    btn
                                    btn-sm
                                    btn-outline-primary
                                "

                                title="Transformar producto"

                                [disabled]="
                                    savingProductId ===
                                        product.product.id
                                    ||
                                    !product.selectedTransformation
                                    ||
                                    product.existingQuantity <= 0
                                "

                                (click)="
                                    transformProduct(product)
                                "
                            >

                                <i
                                    *ngIf="
                                        savingProductId !==
                                        product.product.id
                                    "
                                    class="
                                        fa-solid
                                        fa-right-left
                                    "
                                ></i>


                                <span
                                    *ngIf="
                                        savingProductId ===
                                        product.product.id
                                    "
                                    class="
                                        spinner-border
                                        spinner-border-sm
                                    "
                                ></span>

                            </button>

                        </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</div>